<ng-container [ngSwitch]="layout">
  <!-- Alternativerly use the main layout as the default switch case -->
	<app-daylily-layout *ngSwitchCase="Layouts.DaylilyLayout"></app-daylily-layout>
	<app-feed-layout *ngSwitchCase="Layouts.FeedLayout"></app-feed-layout>
</ng-container>